import { useContext } from 'react';

import {
  PushNotificationsContext,
  PushNotificationsContextValue,
} from './push-notifications-context';

export const usePushNotifications = (): PushNotificationsContextValue => {
  const context = useContext(PushNotificationsContext);

  if (!context) {
    throw new Error(
      'usePushNotifications must be used within a PushNotificationsProvider',
    );
  }

  return context;
};
